import { Button } from '@material-ui/core'
import { Typography } from '@mui/material';
import React from 'react';
import './CardSlider.css';

const CardSlider = (props) => {
    return (
        <div className="card">
            <div style={{ backgroundImage: `url(${props.imgUrl})` }} className="card-image"></div>
            <div className="card-content">
                <Typography
                    variant="h6"
                    component="div"
                    className='title-card'
                    align='center'
                    sx={{ display: { xs: 'flex', md: 'flex' }, mb: '4' }}>
                    {props.title}
                </Typography>
                <Typography
                    variant="p"
                    component="div"
                    className='description-card'
                    align='start'
                    sx={{ display: { xs: 'flex', md: 'flex' }, mb: '4' }}>
                    {props.content}
                </Typography>
            </div>
            <Button variant="outlined" type='button' className='btn-view-project'>View</Button>
        </div>
    )
}

export default CardSlider